// Motion played in script follows the visitor's motion setting, which the
// CSS reduced-motion rule cannot reach.
export const prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
